import "@babel/polyfill";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import VueGoogleAnalytics from "@cb/vue-google-analytics";
import VueGoogleTagManager from "@cb/vue-google-tag-manager";
import filters from "@Shared/filters";
import directives from "@Shared/directives";

Vue.config.productionTip = false;
const isDev = process.env.NODE_ENV !== "production";
Vue.config.performance = isDev;

// Register filters
for (let filter of filters) {
  Vue.filter(filter.name, filter.filter);
}

// Register directives
for (let directive of directives) {
  Vue.directive(directive.name, directive.directive);
}

Vue.use(VueGoogleAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router,
  disabled: true,
  debug: {
    enabled: false,
  },
});

Vue.use(VueGoogleTagManager, {
  id: process.env.VUE_APP_GTM_ID,
  disabled: true,
  debug: true,
  checkDuplicatedScript: true,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
  },
});

Vue.use(VueAxios, axios);
Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
